module.exports = __webpack_public_path__ + "img/facts-grassfield.7746f700.png";